/** Served from `public/no-profile.jpg` (same asset as Flutter `assets/no profile.jpg`). */
export const DEFAULT_PROFILE_IMAGE = '/no-profile.jpg'

/**
 * @param {string | null | undefined} url
 * @returns {string}
 */
export function resolveProfileImageSrc(url) {
  if (url == null) return DEFAULT_PROFILE_IMAGE
  const s = String(url).trim()
  return s !== '' ? s : DEFAULT_PROFILE_IMAGE
}
